var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_894",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H19.9999V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_894)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.664 1.5C3.135 1.5 1.5 3.233 1.5 5.916V14.084C1.5 16.767 3.135 18.5 5.664 18.5H14.332C16.864 18.5 18.5 16.767 18.5 14.084V5.916C18.5 3.233 16.864 1.5 14.334 1.5H5.664ZM14.332 20H5.664C2.276 20 0 17.622 0 14.084V5.916C0 2.378 2.276 0 5.664 0H14.334C17.723 0 20 2.378 20 5.916V14.084C20 17.622 17.723 20 14.332 20Z",
    fill: "#9E9E9E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8388 8.89844C6.2288 8.89844 5.7348 9.39244 5.7348 10.0004C5.7348 10.6084 6.2288 11.1024 6.8368 11.1024C7.4438 11.1024 7.9388 10.6084 7.9388 10.0004C7.9388 9.39344 7.4448 8.89944 6.8388 8.89844ZM6.8368 12.6024C5.4018 12.6024 4.2348 11.4344 4.2348 10.0004C4.2348 8.56544 5.4018 7.39844 6.8368 7.39844C8.2738 7.39944 9.4388 8.56644 9.4388 10.0004C9.4388 11.4344 8.2718 12.6024 6.8368 12.6024Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0097 12.6025C14.5957 12.6025 14.2597 12.2665 14.2597 11.8525V10.7495H8.6917C8.2777 10.7495 7.9417 10.4145 7.9417 9.99951C7.9417 9.58551 8.2777 9.24951 8.6917 9.24951H15.0097C15.4237 9.24951 15.7597 9.58551 15.7597 9.99951V11.8525C15.7597 12.2665 15.4237 12.6025 15.0097 12.6025Z",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1815 12.6025C11.7675 12.6025 11.4315 12.2665 11.4315 11.8525V9.99951C11.4315 9.58551 11.7675 9.24951 12.1815 9.24951C12.5955 9.24951 12.9315 9.58551 12.9315 9.99951V11.8525C12.9315 12.2665 12.5955 12.6025 12.1815 12.6025Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.2067d431c1e28b7bbcd0f75df8a86633.svg";
export { ForwardRef as ReactComponent };